'use strict';

goog.provide("Ntry.CpartyJrResult_2016");

goog.require("Ntry.STATIC");
goog.require("Ntry.Engine");

Ntry.CpartyJrResult_2016 = function() {
    this._view = Ntry.interfaceManager.getDom('ntryResultArea');
    this.path = window.location.pathname;
    if (this.path == '/jr') {
        this.path = this.path + '#!/';
    } else if (this.path == '/codingparty/2016') {
        this.path = this.path + '#!/2/';
    } else {
        this.path = this.path + '/';
    }
    this.createDom();
};

(function(p){

    p.createDom = function () {
        var that = this;
        var ce = Ntry.createElement;
        var menuLang = Lang.Menus;
        var parent = this._view;
        var container = ce('div', parent, null, 'ntryResultContainer');
        var title = ce('div', container, null, 'ntryResultTitle')
        this._closeButton = ce('span', title, null, 'ntryResultCloseButton');
        this._closeButton.innerHTML = menuLang.close;

        var content = ce('div', container, null, 'ntryResultContent');
        this._leftImg = ce('div', content, null, 'ntryResultLeftImg');

        var rightDiv = ce('div', content, null, 'ntryResultRightDiv');
        this._successContent = ce('div', rightDiv, null, 'ntryResultRightContent', 'juni');

        this._usedBlockPrefix = ce('span', this._successContent, null, 'ntryResultContentSpan');

        this._certDiv = ce('div', this._successContent, null, 'ntryResultCertDiv', 'juni', 'ntryRemove');

        this._certDivLeft = ce('div', this._certDiv, null, 'ntryResultCertDivLeft');

        this._certNameLabel = ce('span', this._certDivLeft, null, 'ntryResultContentNameLabel', 'juni');
        this._certNameLabel.innerHTML = menuLang.jr_whats_ur_name;

        this._certNameInput = ce('input', this._certDivLeft, null, 'ntryResultContentNameInput', 'juni');
        this._certNameInput.type = "text";

        this._certLink = ce('div', this._certDiv, null, 'ntryResultContentCert');
        this._certLink.innerHTML = menuLang.jr_down_cert;

        this._failContent = ce('div', rightDiv, null, 'ntryResultRightContent', 'juni');
        this._failCauseString = ce('span', this._failContent, null, 'ntryResultFailCauseSpan');

        this._essentialBlocks = ce('div', this._failContent, null, 'ntryResultEssentialBlocks');

        this._replayButton = ce('span', content, null, 'ntryResultReplayButton');
        this._replayButton.innerHTML = menuLang.replay;

        this._nextButton = ce('span', content, null, 'ntryResultNextButton');
        this._nextButton.innerHTML = menuLang.go_to_next_level;
        this._nextButton.bindOnClick(function() {
            Ntry.setSkipLevelLimitCheck();
            window.location.href = that._nextLink;
        });
    };

    p.randomString = function(len) {
        var charSet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var randomString = '';
        for (var i = 0; i < len; i++) {
            var randomPoz = Math.floor(Math.random() * charSet.length);
            randomString += charSet.substring(randomPoz,randomPoz+1);
        }
        return randomString;
    };

    p.loadConfig = function () {
        Ntry.addEventListener("complete", this, this.complete);
        Ntry.addEventListener("showCert" , this, this.showCert);
    };

    p.showCert = function() {
        this._failContent.ntryRemove();
        $(this._replayButton).css('display', 'none');
        $(this._view).css('display', 'block');

        this._certDiv.ntryShow();
        this._nextButton.ntryRemove();
        this._successContent.ntryShow();
        $(this._certDiv).show();
        $(this._successContent).css('margin-top', '20px');


        this._usedBlockPrefix.innerHTML = "";
        this._leftImg.removeClasses();
        this._leftImg.addClass('ntryResultLeftImg');
        this._leftImg.addClass('jrResultSuccess1Img');

        var self = this;
        this._closeButton.bindOnClick(function() {
            $(self._view).css('display', 'none');
            self._certDiv.ntryRemove();
            // $(self._certDiv).css('display', 'none');
            $(self._replayButton).css('display', 'block');
        });

        // this._replayButton.bindOnClick(function() {
        //     Ntry.dispatchEvent("replay");
        //     $(self._view).css('display', 'none');
        // });

        this._certLink.rebindOnClick(function() {
            var username = self._certNameInput.value;
            if (username === '') {
                alert(Lang.Users.name_not_empty);
                self._certNameInput.focus();
            } else if(window.cpartyuserkey) {
                window.location.href = '/codingparty/2016#!/certificate/'+window.cpartyuserkey+'/'+username +'/2';
            }
        });

        $(this._view).css('display', 'block');
    };

    p.currentUsedBlock = function() {
        var code = getUserCode();

        if (code)
            return code.getEventMap('start')[0]
                .getThread().countBlock()-1;
    };

    function getUserCode() {
        var entities = Ntry.entityManager.
                getEntitiesByComponent(Ntry.STATIC.CODE);

        var entity = entities[Object.keys(entities)[0]];

        if (entity)
            return Ntry.entityManager.getComponent(
                entity.id, Ntry.STATIC.CODE).code;
    };

    p.complete = function(success, cause) {
        var stageId = Ntry.configManager.getConfig("stageId");
        if (stageId) stageId = Number(stageId);

        this._leftImg.removeClasses();
        this._leftImg.addClass('ntryResultLeftImg');

        var self = this;
        this._closeButton.bindOnClick(function() {
            $(self._view).css('display', 'none');
        });

        this._replayButton.bindOnClick(function() {
            Ntry.dispatchEvent("replay");
            $(self._view).css('display', 'none');
        });

        this._nextLink = this.path+(stageId+1);

        this._certLink.rebindOnClick(function() {

            var username = self._certNameInput.value;
            if (username === '') {
                alert(Lang.Users.name_not_empty);
                self._certNameInput.focus();
            } else if(window.cpartyuserkey) {
                window.location.href = '/codingparty/2016#!/certificate/'+window.cpartyuserkey+'/'+username +'/2';
            } else{
                window.location.href = self.path + 'cert/' + username
            }
        });

        var limitBlockCnt =
                Ntry.configManager.getConfig('limitBlockCnt');
        var stageMode =
                Ntry.configManager.getConfig('stageMode');
        var usedBlock = this.currentUsedBlock();
        if (success) {
            if (this.inspectEssential()) {
                this.success(stageId);
                var code = getUserCode().stringify();
                CpartyJRData.player[stageId].userCode = code;
                if (Entry.commander) {
                    Entry.commander.report(
                        null,
                        [
                            'success',
                            ['code', code]
                        ]);
                }
                Ntry.dispatchEvent('saveLogs', 'finish');
            } else {
                this.fail(stageId, Ntry.STATIC.ESSENTIAL_REQUIRED);
            }
        } else {
            this.fail(stageId, cause);
        }

        $(this._view).css('display', 'block');
    };

    p.inspectEssential = function() {
        var essentialBlock =
            Ntry.configManager.getConfig('essentialBlock');
        if (essentialBlock === undefined) return true;

        var entityManager = Ntry.entityManager;

        var code = getUserCode();
        if (_.isEmpty(code)) return false;

        var threads = code.getThreads();
        if (_.isEmpty(threads)) return false;

        var ret = false;
        for(var i=0, len=threads.length; i<len; i++) {
            var thread = threads[i];
            var head = thread.getFirstBlock();

            if (!head || !head._schema.event) continue;

            var blocks = thread.getBlocks();
            for (var j=0; j<blocks.length; j++) {
                var type = blocks[j].type;
                if (type == 'jr_repeat') {
                    ret = true;
                    break;
                }
            }
        }
        return ret;
    };
    p.initState = function(){
        this._replayButton.removeClass('ntryResultReplayButtonFailed');
        this._replayButton.removeClass('ntryResultFailAndReply');
        this._replayButton.addClass("ntryResultReplayButtonFailed");
        this._certDiv.ntryRemove();
    };

    p.success = function(stageId) {
        Ntry.dispatchEvent("jrActivityStageFinish", stageId);
        var limitBlockCnt = Ntry.configManager.getConfig("limitBlockCnt");
        var usedBlockCnt = this.currentUsedBlock();
        this._leftImg.addClass('jrResultSuccess1Img');
        this._leftImg.addClass(Lang.type);

        this._replayButton.removeClass('ntryResultReplayButtonFailed');
        this._replayButton.removeClass('ntryResultFailAndReply');
        this._replayButton.addClass("ntryResultReplayButtonFailed");
        this._certDiv.ntryRemove();

        if (stageId == 15)
            this._replayButton.addClass('juniCert');

        var resultString;
        var menuLang = Lang.Menus;
        if (usedBlockCnt <= limitBlockCnt) {
            this._certNameLabel.addClass('underCnt');
            if (stageId != 15)
                resultString = Lang.Menus.cparty_jr_success_1;
            else
                resultString = menuLang.cparty_jr_result_2;
        } else if (usedBlockCnt > limitBlockCnt) {
            this._certNameLabel.removeClass('underCnt');
            if(stageId == 15 )
                resultString = menuLang.cparty_jr_result_3
            else
                resultString = menuLang.cparty_jr_result_4;
        }

        this._usedBlockPrefix.innerHTML = resultString;

        var nextBtn = this._nextButton;
        if (stageId === 15) {
            this._certDiv.ntryShow();
            nextBtn.ntryRemove();
        } else {
            nextBtn.ntryShow();
        }
        this._successContent.ntryShow();
        this._failContent.ntryRemove();
    };

    p.fail = function(stageId, cause) {
        var theme = 1;

        if (stageId <= 6)
            theme = 1;
        else if (stageId <= 14)
            theme = 2;
        else
            theme = 3;

        var causeString = '';
        var causeStyle = 1;

        var causeMsgs = [
            Lang.Menus.jr_fail_dont_know,
            Lang.Menus.jr_fail_dont_go,
            Lang.Menus.jr_fail_no_pencil,
            Lang.Menus.jr_fail_forgot_pencil,
            Lang.Menus.jr_fail_need_repeat,
            Lang.Menus.jr_fail_much_blocks
        ]

        this._essentialBlocks.removeClasses();
        this._essentialBlocks.ntryRemove();

        switch (cause) {
            case Ntry.STATIC.SIMOOROOK:
                causeString = causeMsgs[0];
                causeStyle = 1;
                break;
            case Ntry.STATIC.WALL_CRASH:
                causeString = causeMsgs[1];
                causeStyle = 3;
                break;
            case Ntry.STATIC.GET_ITEM:
                causeString = causeMsgs[2];
                causeStyle = 2;
                break;
            case Ntry.STATIC.WITHOUT_ITEM_SUCCESS:
                causeString = causeMsgs[3];
                causeStyle = 2;
                break;
            case Ntry.STATIC.ESSENTIAL_REQUIRED:
                causeString = causeMsgs[4];
                causeStyle = 1;
                break;
            case Ntry.STATIC.OVER_LIMITED_BLOCK:
                causeString = causeMsgs[5];
                causeStyle = 1;
                break;
            case Ntry.STATIC.NO_ITEM:
                causeString = causeMsgs[5];
                causeStyle = 1;
                break;
            default:
                causeString = causeMsgs[1];
                causeStyle = 1;
        }

        var imageClass = 'ntryjrResultFail_'+causeStyle;


        this._leftImg.addClass(imageClass);
        this._failCauseString.innerHTML = causeString;

        this._successContent.ntryRemove();
        this._failContent.ntryShow();

        this._nextButton.ntryRemove();
        this._replayButton.removeClasses();
        this._replayButton.addClass("ntryResultFailAndReply");

        if (Entry.commander) {
            Entry.commander.report(
                null,
                [
                    'fail',
                    ['cause', cause],
                    ['code', getUserCode().stringify()]
                ]);
        }
    };

})(Ntry.CpartyJrResult_2016.prototype);
